import { render } from "./Section7.vue?vue&type=template&id=8f6987a2"
import script from "./Section7.vue?vue&type=script&lang=js"
export * from "./Section7.vue?vue&type=script&lang=js"

import "./Section7.vue?vue&type=style&index=0&id=8f6987a2&lang=scss"

import exportComponent from "/Users/kimlong/Documents/Projects/Vuejs/adsota/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__